import { render, staticRenderFns } from "./TransDuration.vue?vue&type=template&id=3da56056&scoped=true&"
import script from "./TransDuration.vue?vue&type=script&lang=js&"
export * from "./TransDuration.vue?vue&type=script&lang=js&"
import style0 from "./TransDuration.vue?vue&type=style&index=0&id=3da56056&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da56056",
  null
  
)

export default component.exports